//checkApp 为全局的 app 对象，checkApp.core 包括了核心 api 
const { Feature, meta, hook } = checkApp.core;//eslint-disable-line

//通过继承 Featrue 实现一个扩展
//meta 用于描述插件的名称、依赖及权重
@meta('buttonLabel', [], 99999)
export default class ButtonLabelFeature extends Feature {

  @hook('checkItemButton.add')
  add() {
    return '加入清单';
  }

  @hook('checkItemButton.remove')
  remove() {
    return '移出清单';
  }

  @hook('checkItemButton.whoisUrl')
  whoisUrl() {
    return '//whois.aliyun.com/whois/domain/{name}';
  }

}


// WEBPACK FOOTER //
// ./src/button-label/index.js